export default "__VITE_ASSET__3108b724__"